import * as ko from "knockout";
import entityBase from "entityBase";

export class searchCriteria extends entityBase {
  Page: KnockoutObservable<number>;
  Rows: KnockoutObservable<number>;
  sort_dir: KnockoutObservable<string>;
  sort_field: KnockoutObservable<string>;
  generalSearch: KnockoutObservable<string>;
  externalSource: KnockoutObservable<boolean>;
  isExport: KnockoutObservable<boolean>;

  constructor(item?: any) {
    super();
    this.Page = ko.observable(item?.Page || 0);
    this.Rows = ko.observable(item?.Rows || 15);
    this.sort_dir = ko.observable(item?.sort_dir);
    this.sort_field = ko.observable(item?.sort_field);
    this.generalSearch = ko.observable(item?.generalSearch);
    this.externalSource = ko.observable(item?.externalSource || false);
    this.isExport = ko.observable(item?.isExport || false);
  }
}
